import { debounce, each, keys, isEmpty, isNil, merge, omit, omitBy, pick, result, toNumber, toString } from 'lodash'
import omitEmpty from 'omit-empty'

const toBoolean = value =>
{
	return ( toString(value).toLowerCase() === 'true' ) ? true : false
}

const FORMATTERS =
{
	'currentPage': toNumber,
	'perPage':     toNumber,
	'filter':      toString,
	'sortBy':      toString,
	'sortDesc':    toBoolean,
}

export default
{
	data()
	{
		return {
			isBusy: true,

			delay:       500,
			currentPage: null,
			perPage:     null,
			totalPages:  null,
			totalRows:   null,
			sortBy:      null,
			sortDesc:    null,
			filter:      null,
			search:      null,
		}
	},

	beforeRouteEnter(to, from, next)
	{
		next(vm => vm.syncFromRoute(to, vm.TABLE_DEFAULTS))
	},

	watch:
	{
		'$route': 'refreshTable',

		'context': 'pushOntoRouter',

		delay:
		{
			immediate: true,

			handler(value)
			{
				this.delayedSearch = debounce(this.setFilterValue, value)
			},
		},

		filter(value)
		{
			this.search = value
		},

		search(value)
		{
			this.delayedSearch(value)
		},
	},

	computed:
	{
		context()
		{
			return pick(this, [ 'currentPage', 'perPage', 'sortBy', 'sortDesc', 'filter' ])
		},

		paginationText()
		{
			const precision = 0
			const start     = ( Math.max(0, this.currentPage - 1) * this.perPage ) + 1
			const end       = Math.min(start + this.perPage - 1, this.totalRows)

			return this.totalRows && `Showing ${this.numberFormat(start, precision)}-${this.numberFormat(end, precision)} of ${this.numberFormat(this.totalRows, precision)}`
		},
	},

	methods:
	{
		tableInitialize()
		{
			this.isBusy = false

			this.$nextTick
			(
				() =>
				{
					if ( !this.loading )
					{
						this.refreshTable()
					}
				}
			)
		},

		async pushOntoRouter()
		{
			try
			{
				await this.$router.push({ name: this.$route.name, query: omitEmpty(pick(this.context, keys(FORMATTERS))) })
			}
			catch(err)
			{
				if ( err?.name !== 'NavigationDuplicated' )
				{
					throw err
				}
			}
		},

		refreshTable()
		{
			return this.$refs?.table?.refresh()
		},

		setFilterValue(value)
		{
			this.$nextTick
			(
				() =>
				{
					this.currentPage = null
					this.filter      = value
				}
			)
		},

		syncFromRoute(route, defaults)
		{
			const object = omitEmpty(pick(merge({}, route.query, route.params), keys(this.context)))

			each
			(
				FORMATTERS,
				(callback, key) =>
				{
					let value = result(object, key)

					if ( isNil(value) )
					{
						value = result(defaults, key, this[key])
					}

					value = callback(value)

					this[key] = value
				}
			)

			this.tableInitialize()
		},

		tableProviderResponse(response)
		{
			const pagination = response?.data?.meta?.pagination

			if ( pagination )
			{
				this.currentPage = pagination.current_page
				this.perPage     = pagination.per_page
				this.totalPages  = pagination.total_pages
				this.totalRows   = pagination.total

				this.$nextTick(() => this.$refs?.table?.$el?.scrollIntoView?.())
			}

			return response?.data?.data
		},
	},
}